import script from "./PromotionEntries.vue?vue&type=script&setup=true&lang=js"
export * from "./PromotionEntries.vue?vue&type=script&setup=true&lang=js"

import "./PromotionEntries.vue?vue&type=style&index=0&id=09625529&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09625529"]])

export default __exports__